import React, { useState, useEffect } from 'react';
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Form,
  FormGroup,
  Label,
  Input,
  FormText,
} from 'reactstrap';
import { expenseApiService } from 'services/expenseApiService';

const UpdateExpenseModal = ({
  isOpen,
  toggle,
  expense,
  onUpdateSuccess
}) => {
  const [formData, setFormData] = useState({
    store_name: '',
    paid_by: '',
    date: '',
    day: '',
    note: '',
    goods_with: '',
    total: '',
    items: [],
  });
  const [loading, setLoading] = useState(false);
  const [receiptFile, setReceiptFile] = useState(null);
  const [receiptPreview, setReceiptPreview] = useState('');

  const days = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

  useEffect(() => {
    if (expense) {
      setFormData({
        store_name: expense.store_name || '',
        paid_by: expense.paid_by || '',
        date: expense.date || '',
        day: expense.day || '',
        note: expense.note || '',
        goods_with: expense.goods_with || '',
        total: expense.total || '',
        items: expense.items || [],
      });
      setReceiptPreview(expense.receipt || '');
    }
  }, [expense]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    const updatedData = { ...formData, [name]: value };

    // Update day when date changes
    if (name === 'date' && value) {
      const selectedDate = new Date(value);
      const dayName = days[selectedDate.getDay()];
      updatedData.day = dayName;
    }

    setFormData(updatedData);
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setReceiptFile(file);

      // Create preview
      const reader = new FileReader();
      reader.onloadend = () => {
        setReceiptPreview(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  const handleItemChange = (index, field, value) => {
    const updatedItems = [...formData.items];
    updatedItems[index] = {
      ...updatedItems[index],
      [field]: value
    };
    setFormData(prev => ({ ...prev, items: updatedItems }));
  };

  const addItem = () => {
    setFormData(prev => ({
      ...prev,
      items: [...prev.items, { name: '', price: '', quantity: '' }]
    }));
  };

  const removeItem = (index) => {
    const updatedItems = [...formData.items];
    updatedItems.splice(index, 1);
    setFormData(prev => ({ ...prev, items: updatedItems }));
  };

  const calculateTotal = () => {
    const total = formData.items.reduce((sum, item) => {
      const price = parseFloat(item.price) || 0;
      const quantity = parseFloat(item.quantity) || 0;
      return sum + (price * quantity);
    }, 0);
    setFormData(prev => ({ ...prev, total: total.toFixed(2) }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const dataToSend = new FormData();
      dataToSend.append('store_name', formData.store_name);
      dataToSend.append('paid_by', formData.paid_by);
      dataToSend.append('date', formData.date);
      dataToSend.append('day', formData.day);
      dataToSend.append('note', formData.note);
      dataToSend.append('goods_with', formData.goods_with);
      dataToSend.append('total', formData.total);
      dataToSend.append('items', JSON.stringify(formData.items));

      if (receiptFile) {
        dataToSend.append('receipt', receiptFile);
      }

      await expenseApiService.updateExpense(expense.id, dataToSend);

      onUpdateSuccess();
      toggle();
    } catch (error) {
      console.error('Error updating expense:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal isOpen={isOpen} toggle={toggle} size="lg">
      <ModalHeader toggle={toggle}>Update Expense</ModalHeader>
      <Form onSubmit={handleSubmit}>
        <ModalBody>
          <div className="row">
            <div className="col-md-6">
              <FormGroup>
                <Label for="store_name">Store Name *</Label>
                <Input
                  type="text"
                  id="store_name"
                  name="store_name"
                  value={formData.store_name}
                  onChange={handleChange}
                  required
                />
              </FormGroup>



              <FormGroup>
                <Label for="date">Date *</Label>
                <Input
                  type="date"
                  id="date"
                  name="date"
                  value={formData.date}
                  onChange={handleChange}
                  required
                />
              </FormGroup>
              <FormGroup>
                <Label for="receipt">Receipt Image</Label>
                <Input
                  type="file"
                  id="receipt"
                  name="receipt"
                  onChange={handleFileChange}
                  accept="image/*"
                />
                {/* <FormText>
                  Leave empty to keep current receipt
                </FormText> */}

                {receiptPreview && (
                  <div className="mt-2">
                    <img
                      src={receiptPreview}
                      alt="Receipt preview"
                      style={{
                        width: '100px',
                        height: '100px',
                        objectFit: 'cover',
                        borderRadius: '4px',
                        border: '1px solid #ddd',
                      }}
                    />
                  </div>
                )}
              </FormGroup>

              <FormGroup>
                <Label for="note">Note</Label>
                <Input
                  type="textarea"
                  id="note"
                  name="note"
                  value={formData.note}
                  onChange={handleChange}
                  rows="2"
                />
              </FormGroup>

            </div>

            <div className="col-md-6">
              <FormGroup>
                <Label for="paid_by">Paid By *</Label>
                <Input
                  type="text"
                  id="paid_by"
                  name="paid_by"
                  value={formData.paid_by}
                  onChange={handleChange}
                  required
                />
              </FormGroup>

              <FormGroup>
                <Label for="day">Day</Label>
                <Input
                  type="text"
                  id="day"
                  name="day"
                  value={formData.day}
                  readOnly
                />
              </FormGroup>
              <FormGroup>
                <Label for="goods_with">Goods With</Label>
                <Input
                  type="text"
                  id="goods_with"
                  name="goods_with"
                  value={formData.goods_with}
                  onChange={handleChange}
                />
              </FormGroup>








            </div>
          </div>

          {/* Items Section */}
          <div className="mt-3">
            <div className="d-flex justify-content-between align-items-center mb-2">
              <h6>Items</h6>
              <Button type="button" color="primary" size="sm" onClick={addItem}>
                <i className="fas fa-plus me-1"></i> Add Item
              </Button>
            </div>

            {formData.items.map((item, index) => (
              <div key={index} className="row mb-2">
                <div className="col-md-4">
                  <Input
                    type="text"
                    placeholder="Item name"
                    value={item.name}
                    onChange={(e) => handleItemChange(index, 'name', e.target.value)}
                    required
                  />
                </div>
                <div className="col-md-3">
                  <Input
                    type="number"
                    placeholder="Price"
                    value={item.price}
                    onChange={(e) => handleItemChange(index, 'price', e.target.value)}
                    step="0.01"
                    min="0"
                    required
                  />
                </div>
                <div className="col-md-3">
                  <Input
                    type="number"
                    placeholder="Quantity"
                    value={item.quantity}
                    onChange={(e) => handleItemChange(index, 'quantity', e.target.value)}
                    min="1"
                    required
                  />
                </div>
                <div className="col-md-2">
                  <Button
                    type="button"
                    color="danger"
                    size="sm"
                    onClick={() => removeItem(index)}
                  >
                    <i className="fas fa-trash"></i>
                  </Button>
                </div>
              </div>
            ))}

            <div className="row mt-4">
              <div className="col-md-6">
                <Button type="button" color="secondary" size="sm" onClick={calculateTotal}>
                  Calculate Total
                </Button>


              </div>
              <div className="col-md-6">
                <FormGroup style={{ display: "flex", alignItems: "center" }}>
                  <Label style={{ width: "70px" }} for="total">Total *</Label>
                  <Input
                    type="number"
                    id="total"
                    name="total"
                    value={formData.total}
                    onChange={handleChange}
                    required
                    step="0.01"
                  />
                </FormGroup>
              </div>
            </div>
          </div>
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={toggle} disabled={loading}>
            Cancel
          </Button>
          <Button color="primary" type="submit" disabled={loading}>
            {loading ? (
              <>
                <span className="spinner-border spinner-border-sm me-1"></span>
                Updating...
              </>
            ) : (
              'Update Expense'
            )}
          </Button>
        </ModalFooter>
      </Form>
    </Modal>
  );
};

export default UpdateExpenseModal;

// import React, { useState, useEffect } from 'react';
// import {
//   Modal,
//   ModalHeader,
//   ModalBody,
//   ModalFooter,
//   Button,
//   Form,
//   FormGroup,
//   Label,
//   Input,
//   FormText,
// } from 'reactstrap';
// import { expenseApiService } from 'services/expenseApiService';

// const UpdateExpenseModal = ({
//   isOpen,
//   toggle,
//   expense,
//   onUpdateSuccess
// }) => {
//   const [formData, setFormData] = useState({
//     store_name: '',
//     paid_by: '',
//     date: '',
//     day: '',
//     note: '',
//     goods_with: '',
//     total: '',
//     items: [],
//   });
//   const [loading, setLoading] = useState(false);
//   const [receiptFile, setReceiptFile] = useState(null);
//   const [receiptPreview, setReceiptPreview] = useState('');

//   const days = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

//   useEffect(() => {
//     if (expense) {
//       setFormData({
//         store_name: expense.store_name || '',
//         paid_by: expense.paid_by || '',
//         date: expense.date || '',
//         day: expense.day || '',
//         note: expense.note || '',
//         goods_with: expense.goods_with || '',
//         total: expense.total || '',
//         items: expense.items || [],
//       });
//       setReceiptPreview(expense.receipt || '');
//     }
//   }, [expense]);

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     const updatedData = { ...formData, [name]: value };

//     // Update day when date changes
//     if (name === 'date' && value) {
//       const selectedDate = new Date(value);
//       const dayName = days[selectedDate.getDay()];
//       updatedData.day = dayName;
//     }

//     setFormData(updatedData);
//   };

//   const handleFileChange = (e) => {
//     const file = e.target.files[0];
//     if (file) {
//       setReceiptFile(file);

//       // Create preview
//       const reader = new FileReader();
//       reader.onloadend = () => {
//         setReceiptPreview(reader.result);
//       };
//       reader.readAsDataURL(file);
//     }
//   };

//   const handleItemChange = (index, field, value) => {
//     const updatedItems = [...formData.items];
//     updatedItems[index] = {
//       ...updatedItems[index],
//       [field]: value
//     };
//     setFormData(prev => ({ ...prev, items: updatedItems }));
//   };

//   const addItem = () => {
//     setFormData(prev => ({
//       ...prev,
//       items: [...prev.items, { name: '', price: '', quantity: '' }]
//     }));
//   };

//   const removeItem = (index) => {
//     const updatedItems = [...formData.items];
//     updatedItems.splice(index, 1);
//     setFormData(prev => ({ ...prev, items: updatedItems }));
//   };

//   const calculateTotal = () => {
//     const total = formData.items.reduce((sum, item) => {
//       const price = parseFloat(item.price) || 0;
//       const quantity = parseFloat(item.quantity) || 0;
//       return sum + (price * quantity);
//     }, 0);
//     setFormData(prev => ({ ...prev, total: total.toFixed(2) }));
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setLoading(true);

//     try {
//       const dataToSend = new FormData();
//       dataToSend.append('store_name', formData.store_name);
//       dataToSend.append('paid_by', formData.paid_by);
//       dataToSend.append('date', formData.date);
//       dataToSend.append('day', formData.day);
//       dataToSend.append('note', formData.note);
//       dataToSend.append('goods_with', formData.goods_with);
//       dataToSend.append('total', formData.total);
//       dataToSend.append('items', JSON.stringify(formData.items));

//       if (receiptFile) {
//         dataToSend.append('receipt', receiptFile);
//       }

//       await expenseApiService.updateExpense(expense.id, dataToSend);

//       onUpdateSuccess();
//       toggle();
//     } catch (error) {
//       console.error('Error updating expense:', error);
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <Modal isOpen={isOpen} toggle={toggle} size="lg">
//       <ModalHeader toggle={toggle}>Update Expense</ModalHeader>
//       <Form onSubmit={handleSubmit}>
//         <ModalBody>
//           <div className="row">
//             <div className="col-md-6">
//               <FormGroup>
//                 <Label for="store_name">Store Name *</Label>
//                 <Input
//                   type="text"
//                   id="store_name"
//                   name="store_name"
//                   value={formData.store_name}
//                   onChange={handleChange}
//                   required
//                 />
//               </FormGroup>

//               <FormGroup>
//                 <Label for="paid_by">Paid By *</Label>
//                 <Input
//                   type="text"
//                   id="paid_by"
//                   name="paid_by"
//                   value={formData.paid_by}
//                   onChange={handleChange}
//                   required
//                 />
//               </FormGroup>

//               <FormGroup>
//                 <Label for="date">Date *</Label>
//                 <Input
//                   type="date"
//                   id="date"
//                   name="date"
//                   value={formData.date}
//                   onChange={handleChange}
//                   required
//                 />
//               </FormGroup>

//               <FormGroup>
//                 <Label for="day">Day</Label>
//                 <Input
//                   type="text"
//                   id="day"
//                   name="day"
//                   value={formData.day}
//                   readOnly
//                 />
//               </FormGroup>
//             </div>

//             <div className="col-md-6">
//               <FormGroup>
//                 <Label for="note">Note</Label>
//                 <Input
//                   type="textarea"
//                   id="note"
//                   name="note"
//                   value={formData.note}
//                   onChange={handleChange}
//                   rows="2"
//                 />
//               </FormGroup>

//               <FormGroup>
//                 <Label for="goods_with">Goods With</Label>
//                 <Input
//                   type="text"
//                   id="goods_with"
//                   name="goods_with"
//                   value={formData.goods_with}
//                   onChange={handleChange}
//                 />
//               </FormGroup>

//               <FormGroup>
//                 <Label for="receipt">Receipt Image</Label>
//                 <Input
//                   type="file"
//                   id="receipt"
//                   name="receipt"
//                   onChange={handleFileChange}
//                   accept="image/*"
//                 />
//                 <FormText>
//                   Leave empty to keep current receipt
//                 </FormText>

//                 {receiptPreview && (
//                   <div className="mt-2">
//                     <img
//                       src={receiptPreview}
//                       alt="Receipt preview"
//                       style={{
//                         width: '100px',
//                         height: '100px',
//                         objectFit: 'cover',
//                         borderRadius: '4px',
//                         border: '1px solid #ddd',
//                       }}
//                     />
//                   </div>
//                 )}
//               </FormGroup>

//               <FormGroup>
//                 <Label for="total">Total *</Label>
//                 <Input
//                   type="number"
//                   id="total"
//                   name="total"
//                   value={formData.total}
//                   onChange={handleChange}
//                   required
//                   step="0.01"
//                 />
//               </FormGroup>
//             </div>
//           </div>

//           {/* Items Section */}
//           <div className="mt-3">
//             <div className="d-flex justify-content-between align-items-center mb-2">
//               <h6>Items</h6>
//               <Button type="button" color="primary" size="sm" onClick={addItem}>
//                 <i className="fas fa-plus me-1"></i> Add Item
//               </Button>
//             </div>

//             {formData.items.map((item, index) => (
//               <div key={index} className="row mb-2">
//                 <div className="col-md-4">
//                   <Input
//                     type="text"
//                     placeholder="Item name"
//                     value={item.name}
//                     onChange={(e) => handleItemChange(index, 'name', e.target.value)}
//                     required
//                   />
//                 </div>
//                 <div className="col-md-3">
//                   <Input
//                     type="number"
//                     placeholder="Price"
//                     value={item.price}
//                     onChange={(e) => handleItemChange(index, 'price', e.target.value)}
//                     step="0.01"
//                     min="0"
//                     required
//                   />
//                 </div>
//                 <div className="col-md-3">
//                   <Input
//                     type="number"
//                     placeholder="Quantity"
//                     value={item.quantity}
//                     onChange={(e) => handleItemChange(index, 'quantity', e.target.value)}
//                     min="1"
//                     required
//                   />
//                 </div>
//                 <div className="col-md-2">
//                   <Button
//                     type="button"
//                     color="danger"
//                     size="sm"
//                     onClick={() => removeItem(index)}
//                   >
//                     <i className="fas fa-trash"></i>
//                   </Button>
//                 </div>
//               </div>
//             ))}

//             <div className="mt-2">
//               <Button type="button" color="secondary" size="sm" onClick={calculateTotal}>
//                 Calculate Total
//               </Button>
//             </div>
//           </div>
//         </ModalBody>
//         <ModalFooter>
//           <Button color="secondary" onClick={toggle} disabled={loading}>
//             Cancel
//           </Button>
//           <Button color="primary" type="submit" disabled={loading}>
//             {loading ? (
//               <>
//                 <span className="spinner-border spinner-border-sm me-1"></span>
//                 Updating...
//               </>
//             ) : (
//               'Update Expense'
//             )}
//           </Button>
//         </ModalFooter>
//       </Form>
//     </Modal>
//   );
// };

// export default UpdateExpenseModal;